module.exports = __webpack_public_path__ + "static/img/yx4.c0abb2e6.png";